import asArray from 'utils/arrays/asArray.util';

const calculateTotalSumPayments = (payments) =>
  asArray(payments).reduce(
    (total, payment) => ({
      count: total.count + payment.count,
      amount: total.amount + payment.amount,
      transfers: total.transfers + payment.transfers,
      fee_exc_vat: total.fee_exc_vat + payment.fee_exc_vat,
      vat: total.vat + payment.vat,
      fee_inc_vat: total.fee_inc_vat + payment.fee_inc_vat,
    }),
    {
      count: 0,
      amount: 0,
      transfers: 0,
      fee_exc_vat: 0,
      vat: 0,
      fee_inc_vat: 0,
    },
  );

export default calculateTotalSumPayments;
